// extracted by mini-css-extract-plugin
module.exports = {"rightSection":"Header_rightSection__1RKEX","rightSectionAction":"Header_rightSectionAction__23F9r"};